import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-panel-acciones',
  templateUrl: './panel-acciones.component.html',
  styleUrls: ['./panel-acciones.component.scss']
})

export class PanelAccionesComponent implements OnInit {

  @Input() iconos : any = [];

  constructor() { }

  ngOnInit(): void {
  }

}
